import { Component, OnInit, ViewChild, ElementRef, } from '@angular/core';
import * as firebase from 'firebase';
import { ImageCropperComponent, CropperSettings } from 'ng2-img-cropper';
import { MatDialog } from '@angular/material';
import { ImageCropComponent } from '../../directive/image-crop/image-crop.component';
import { UserService } from '../../_services/user.service';
import { ImageToDataUrlService } from '../../_services/image-to-data-url/image-to-data-url.service';
import { ResizeOptions } from 'ng2-imageupload';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'photo-upload',
  templateUrl: './photo-upload.component.html',
  styleUrls: ['./photo-upload.component.css']
})
export class PhotoUploadComponent implements OnInit {
  userId = localStorage.getItem("currentUserId");
  user: any;
  data1: any;
  data2: any;
  cropperSettings1: CropperSettings;
  cropperSettings2: CropperSettings;
  private subscription: Subscription = new Subscription();
  img: any;
  resizeOptions: ResizeOptions = {
    resizeMaxHeight: 200,
    resizeMaxWidth: 200
  }
  images: any[] = [];
  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
  @ViewChild('profileImageInput') profileImage: ElementRef;
  @ViewChild('coverImageInput') coverImage: ElementRef;

  constructor(
    private userService: UserService,
    private imageResize: ImageToDataUrlService,
    private afs: AngularFirestore,
    public dialog: MatDialog) {

    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));

    this.cropperSettings1 = new CropperSettings();
    this.cropperSettings1.width = 1076;
    this.cropperSettings1.height = 400;
    this.cropperSettings1.croppedWidth = 1614;
    this.cropperSettings1.croppedHeight = 600;
    this.cropperSettings1.canvasWidth = window.matchMedia('(max-width: 768px)').matches ? 250 : 500;
    this.cropperSettings1.canvasHeight = window.matchMedia('(max-width: 768px)').matches ? 150 : 300;
    this.cropperSettings1.noFileInput = true;
    this.cropperSettings1.rounded = false;
    this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
    this.cropperSettings1.cropperDrawSettings.strokeWidth = 2;

    this.data1 = {};

    this.cropperSettings2 = new CropperSettings();
    this.cropperSettings2.width = 10;
    this.cropperSettings2.height = 10;
    this.cropperSettings2.keepAspect = false;
    this.cropperSettings2.croppedWidth = 600;
    this.cropperSettings2.croppedHeight = 600;
    this.cropperSettings1.canvasWidth = window.matchMedia('(max-width: 768px)').matches ? 250 : 500;
    this.cropperSettings1.canvasHeight = window.matchMedia('(max-width: 768px)').matches ? 150 : 300;
    this.cropperSettings2.minWidth = 200;
    this.cropperSettings2.minHeight = 200;
    this.cropperSettings2.rounded = true;
    this.cropperSettings2.noFileInput = true;
    this.cropperSettings2.minWithRelativeToResolution = false;
    this.cropperSettings2.cropperDrawSettings.strokeColor = 'rgba(255,125,125,1)';
    this.cropperSettings2.cropperDrawSettings.strokeWidth = 2;

    this.data2 = {};
  }

  ngOnDestroy() {


    this.subscription.unsubscribe();
  }

  uploadImage(image, imageType) {

    return firebase.storage().ref('/files/' + this.userId).child(imageType).putString(image, 'data_url').then(() => {

      if (imageType === "coverImage") {

        this.afs.collection('users').doc(this.userId).update({ coverImage: this.userId + '%2FcoverImage' }).then(() => {
          window.location.reload();
        })
      }
      if (imageType === 'profileImage') {
        this.afs.collection('users').doc(this.userId).update({ profileImage: this.userId + '%2FprofileImage' }).then(() => {
          window.location.reload();
        })

      }

    });
  }

  cropImage(event, cropperSettings, imageType) {
    let dialogRef = this.dialog.open(ImageCropComponent, {
      data: { "cropperSettings": cropperSettings, "image": event.target.files[0] }
    });

    this.profileImage.nativeElement.value = null;
    this.coverImage.nativeElement.value = null;

    const sub = dialogRef.componentInstance.getCroppedImage().subscribe(image => {

      if (imageType == "profileImage") {
        let resizeOptions = [{
          maxHeight: 128,
          maxWidth: 128
        }, {
          maxHeight: 64,
          maxWidth: 64
        }, {
          maxHeight: 45,
          maxWidth: 45
        }];
        let count = 0;
        resizeOptions.forEach(option => {
          this.imageResize.readBase64([image], { resize: option }, imageResult => {
            let src = imageResult.resized
              && imageResult.resized.dataURL
              || imageResult.dataURL;
            firebase.storage().ref('/files/' + this.userId).child("profileImage_" + option.maxHeight + "_thumb").putString(src, "data_url").then(() => {
              if (++count == resizeOptions.length) this.uploadImage(image, imageType);
            });
          });
        })
      } else {
        this.uploadImage(image, imageType);
      }
    });
    dialogRef.afterClosed().subscribe(() => sub.unsubscribe());
  }
  public blobToFile = (theBlob: Blob, fileName: string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/photo-upload/photo-upload.component.ts